export const OPEN_SNACKBAR = "OPEN_SNACKBAR";
export const SET_OPEN = "SET_OPEN";
export const SET_MESSAGE_INFO = "SET_MESSAGE_INFO";
export const SET_SNACKPACK = "SET_SNACKPACK";
export const OPEN_PROMPT = "OPEN_PROMPT";
